import 'appdevresources/select2.cacheableajax.adapter';
import common from 'appdevresources/common';
import Routing from 'appdevresources/router';
import 'searchautocomplete/jquery.ajaxautocomplete.widget';

$(async function () {
    const searchForm = $('[name="search-form"].student-search');
    const studentPidm = searchForm.find('[name="selected-pidm"]');
    const searchBox = searchForm.find('.person-search');
    const prevSearchName = $('[name="previous-search-name"]:first').val();
    const prevSearchId = $('[name="previous-search-id"]:first').val();

    searchBox.val(prevSearchName);
    $('[name="student-search"]').val(prevSearchName);
    studentPidm.val(prevSearchId);

    searchBox.ajaxAutocomplete({
        showExpandedResults: true,
        submitOnSelect: true,
        url: Routing.generate('api_search'),
    });

    $('body').mousedown(function (e) {
        if (!$(e.target).parents('[name="search-form"].student-search').length && !$(e.target).parents('ul.ui-autocomplete').length) {
            searchBox.val(prevSearchName);
            studentPidm.val(prevSearchId);
        }
    });

    $('[name=student-search-button]').on('click',function (e) {
        e.preventDefault();
        search($(e.target).parents('form'));
    })

    searchBox.keydown(function (e) {
        if (e.which === 13) {
            search($(e.target).parents('form'));
        }
    });

    function search(activeForm) {
        const searchString = activeForm.find('[name="student-search"]').val();
        const isNumericSearch = /^\d+$/.test(searchString);
        if (!isNumericSearch || (isNumericSearch && searchString.length !== 9)) {
            return false;
        }
        common.loadSpinner();
        activeForm.submit();
    }
});
